import { isToggleElement, errorMessage, removeElement, getSpinner } from './components/elements';
import { addUserForm, renderUserForm } from './components/form';
import { updateDictionary, renderTextBook } from './components/dictionary/dictionary';
import { controllers } from '../controllers/controller';
import { showStatisticsModal } from './components/statistics';
var showAdaptiveMenu = function () {
    var buttonMenu = document.querySelector('.menu__button');
    buttonMenu.addEventListener('click', function () {
        ['.menu__button', '.menu-adaptive'].forEach(function (element) {
            isToggleElement(element);
        });
    });
};
var renderFormUser = function () {
    var buttonsSign = document.querySelectorAll('.menu-sign');
    var buttonsLogout = document.querySelectorAll('.menu-user-name');
    var showModalUser = function (element) {
        element.addEventListener('click', function () {
            isToggleElement('.user-handler');
            renderUserForm();
        });
    };
    buttonsSign.forEach(function (button) {
        showModalUser(button);
    });
    buttonsLogout.forEach(function (button) {
        showModalUser(button);
    });
};
var changeGroupWords = function () {
    var buttons = document.querySelector('.dictionary__lists');
    buttons.addEventListener('click', function (e) {
        var target = e.target;
        var group = target.dataset.group;
        var lists = Object.values(target.classList);
        if (lists.includes('dictionary__button') && !lists.includes('dictionary__button-active')) {
            controllers.wordsGroup = group;
            controllers.wordsPage = 1;
            view.updateViewDictionary();
            if (controllers.wordsGroup === '6') {
                controllers.getDataWordsDifficult();
            }
            else {
                controllers.getDataWords();
            }
        }
    }, true);
};
var addErrorLogin = function (type) {
    var message = document.querySelector('#user-sign-msg-holder');
    message.insertAdjacentHTML('afterend', errorMessage(type));
    removeElement('#user-error-msg-holder');
};
var showVideo = function () {
    // const containerVideo: HTMLDivElement = document.querySelector('about-video');
    var buttonVideo = document.querySelector('.button__video');
    buttonVideo.addEventListener('click', function () {
        isToggleElement('.about-video');
    });
};
var clickButtons = function () {
    showAdaptiveMenu();
    renderFormUser();
    changeGroupWords();
    showVideo();
};
var view = {
    init: function () {
        var section = document.querySelector('.user-handler');
        section.append(addUserForm());
        clickButtons();
        view.updateViewDictionary();
    },
    renderUserMessageError: function (type) {
        addErrorLogin(type);
    },
    closeModalUserSign: function () {
        isToggleElement('.user-handler');
    },
    renderUserLogin: function (name) {
        var header = document.querySelector('header');
        var buttonsUser = document.querySelectorAll('.menu-user-name');
        if (controllers.isUserSignIn) {
            if (!header.classList.contains('login'))
                header.classList.add('login');
            buttonsUser.forEach(function (button) {
                button.textContent = name;
            });
        }
        else {
            if (header.classList.contains('login'))
                header.classList.remove('login');
        }
        view.updateViewDictionary();
        view.renderWordsDictionary();
        showStatisticsModal();
    },
    updateViewDictionary: function () {
        updateDictionary();
    },
    renderWordsDictionary: function () {
        var lists = document.querySelector('.word__cards');
        while (lists.firstChild) {
            lists.removeChild(lists.firstChild);
        }
        renderTextBook(controllers.isUserSignIn, "".concat(controllers.wordsGroup));
    },
    showSpinnerWords: function () {
        var listsWordCard = document.querySelector('.word__cards');
        var cardsWord = listsWordCard.querySelectorAll('.word');
        cardsWord.forEach(function (item) {
            getSpinner.show(item);
        });
    },
};
export { view };
